<template>
	<div ref="vipcharge" class="vipcharge" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="7" style="color:transparent"><div>1</div></el-col>
			<el-col :span="10">
				<el-card>
					<div class="tips"><span>正数代表金额增加，负数代表金额减少</span></div>
					<div class="money">
						总金额：
						<span class="vacancy">{{ vacancy }}</span>
						可用余额：
						<span class="ye">{{ ye }}</span>
						信用额度：
						<span class="quota">{{ quota }}</span>
					</div>
					<el-form label-width="80px">
						<el-form-item label="会员卡号" style="font-size:15pt;">
							<el-autocomplete
								ref="vipaccount"
								:trigger-on-focus="false"
								v-model="vipaccount"
								:fetch-suggestions="searchvip"
								placeholder="请输入会员卡\账号\姓名"
								@select="checkvipaccount"
								value-key="vipaccount"
								style="width:100%"
								@input="inputchange"
								@keyup.native="val => enterinput(val, 'amount','')"
							>
								<template slot-scope="{ item }">
									<div>{{ item.vipaccount }} ( {{ item.u_name }} {{ item.u_account }} )</div>
								</template>
							</el-autocomplete>
						</el-form-item>
						<el-form-item label="充值金额" style="font-size:15pt;">
							<el-input
								ref="amount"
								v-model="amount"
								type="Number"
								placeholder="请输入充值金额"
								@input="inputchange"
								@keyup.native="val => enterinput(val,'remark', 'vipaccount')"
							></el-input>
						</el-form-item>
						<el-form-item label="备注"  style="font-size:15pt;">
							<el-input ref="remark" v-model="remark" @keyup.native="val => enterinput(val, '','amount')"></el-input>
						</el-form-item>
						<el-form-item style="padding-left:20%">
							<el-button ref="sure" type="success" @click="surecharge" :disabled="savedisabled">充值</el-button>
							<el-button ref="cancel" @click="cancelcharge" style="margin-left:10px">取消</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
			<el-col :span="7" style="color:#ffffff;text-align:left"></el-col>
		</el-row>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="400px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">充值成功</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11" style="text-align:right;"><el-button type="primary" size="medium" @click="init">继续充值</el-button></el-col>
				<el-col :span="2" style="color:transparent">1</el-col>
				<el-col :span="11" style="text-align:left;"><el-button size="medium" @click="cancelcharge">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	data() {
		return {
			vacancy: '0.00',
			ye: '0.00',
			quota: '0.00',
			vipaccount: '',
			amount: '',
			remark: '',
			windowHeight: window.innerHeight - 120,
			mode: '会员列表',
			savedisabled: true,
			showsuccesswin: false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/vipcharge.scss');
		});
	},
	methods: {
		init() {
			this.vacancy = '0.00';
			this.ye = '0.00';
			this.quota = '0.00';
			this.vipaccount = '';
			this.amount = '';
			this.remark = '';
			this.savedisabled = true;
			this.showsuccesswin=false;
			this.$refs['vipaccount'].focus();
		},
		checkvipaccount(val) {
			this.vacancy = val.vacancy.toString();
			this.ye = val.ye.toString();
			this.quota = val.quota.toString();
		},
		inputchange() {
			if (this.vipaccount.trim() != '' && this.amount.trim() != '') {
				this.savedisabled = false;
			} else {
				this.savedisabled = true;
			}
		},
		//确认充值
		surecharge() {
			if (this.vipaccount.trim() == '') {
				this.$tool.message('请输入会员卡', 0);
				return false;
			}
			if (this.amount.trim() == '') {
				this.$tool.message('请输入充值金额', 0);
				return false;
			}
			var that = this;
			var payparam = {
				vipaccount: this.vipaccount,
				p_paytype: '人工充值',
				amount: this.amount,
				remark: this.remark,
				u_userid: localStorage.getItem('userid'),
				u_name: localStorage.getItem('u_name')
			};
			that.savedisabled=true;
			//if(2>1) return false;
			this.$apipost.post.SaveVipCharge({ payparam: payparam }).then(res => {
				that.savedisabled=false;
				if (res.state == '1') {
					that.showsuccesswin = true;
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		cancelcharge() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		GetSearchObj() {
			var searchinfo = {
				searchbox: this.vipaccount
			};
			return searchinfo;
		},
		searchvip(val, cb) {
			var that = this;
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: that.mode,
						tab: '',
						search: that.GetSearchObj(),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}
			}, 300);
		},
		enterinput(event, next, perv) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if(next!='')
						this.$refs[next].focus();
				} else if (event.keyCode == 37) {
					if(perv!='')
						this.$refs[perv].focus();
				}
			}
		}
	}
};
</script>

<style></style>
